import { Component, OnDestroy, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UiService } from '../../services/ui.service';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(
    public uiService: UiService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.uiService.showMessageEvent
      .pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        if (result && result.severity && result.detail) {
          this.messageService.clear();
          this.messageService.add({
            severity: result.severity,
            summary: result.summary || '',
            detail: result.detail,
            life: 5000
          });
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  closeDialog() {
    this.uiService.isShowMessage = false;
  }
}
